import { ApolloCache, ModifierDetails } from '@apollo/client/cache'

export const evictCache = <T>(cache: ApolloCache<T>, typename: string, id: string) => {
  cache.modify({
    id: cache.identify({ __typename: typename, id }),
    fields: (_, { DELETE }): ModifierDetails['DELETE'] => DELETE,
  })
}
